import {useForm} from 'react-hook-form'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'
import SelectInput from '../../shared/SelectInput'

import {DISABLED, ENABLED} from '../../../lib/featureFlags'

// A row reaches everyone by leaving `ownableId` unset, so the scope is a question the form asks
// rather than a column it writes — only the account answer puts anything in the payload.
export const ACCOUNT_SCOPE = 'account'
export const EVERYONE_SCOPE = 'everyone'

const SCOPES = [
  {label: 'All users', value: EVERYONE_SCOPE},
  {label: 'A single account', value: ACCOUNT_SCOPE}
]

const STARTING_STATES = [
  {label: 'Disabled', value: DISABLED},
  {label: 'Enabled', value: ENABLED}
]

const FlagForm = props => {
  const methods = useForm({defaultValues: {scope: EVERYONE_SCOPE, value: DISABLED}})
  const {errors} = methods.formState
  const scope = methods.watch('scope')

  return (
    <Stack className='flag-form'>
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.name}
          label='Name'
          name='name'
          options={{
            required: 'Name is required',
            pattern: {value: /^[A-Z][A-Z0-9_]*$/, message: 'Use uppercase letters, digits and underscores'}
          }}
          helperText={errors.name?.message || 'The name the code will read. It does not have to exist there yet.'}
          margin='dense'
        />
        <SelectInput
          error={!!errors.scope}
          label='Scope'
          name='scope'
          items={SCOPES}
          options={{required: 'Scope is required'}}
          helperText={errors.scope?.message}
          defaultValue={EVERYONE_SCOPE}
          margin='dense'
        />
        {
          scope === ACCOUNT_SCOPE && (
            <SelectInput
              error={!!errors.ownableId}
              label='Account'
              name='ownableId'
              items={props.accounts}
              options={{required: 'Account is required'}}
              helperText={errors.ownableId?.message || 'Only this account is reached by the flag.'}
              margin='dense'
            />
          )
        }
        <SelectInput
          error={!!errors.value}
          label='Starts as'
          name='value'
          items={STARTING_STATES}
          options={{required: 'Starting state is required'}}
          helperText={errors.value?.message}
          defaultValue={DISABLED}
          margin='dense'
        />
        <Alert className='notice' severity='info'>
          Flags made here can be rescoped, switched off and renamed later. TFA_BYPASS is the one that
          cannot — it is capped at a single account and granted from that account's own page.
        </Alert>
        <Button disabled={props.loading} type='submit' variant='contained' sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </FormWrapper>
    </Stack>
  )
}

export default FlagForm
